(() => {
  const initAnimation = (section) => {
    if (!section.classList.contains("js-do-animate")) return;

    const targets = section.querySelectorAll(".js-do-target");
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-inview");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" },
    );

    targets.forEach((target) => observer.observe(target));
  };

  const initReadMore = (section) => {
    section.querySelectorAll("[data-do-toggle]").forEach((toggle) => {
      if (toggle.dataset.doToggleReady === "true") return;

      const panel = document.getElementById(
        toggle.getAttribute("aria-controls"),
      );
      if (!panel) return;

      toggle.dataset.doToggleReady = "true";

      toggle.addEventListener("click", () => {
        const willOpen = toggle.getAttribute("aria-expanded") !== "true";

        toggle.setAttribute("aria-expanded", String(willOpen));
        panel.classList.toggle("is-open", willOpen);

        const label = willOpen
          ? toggle.dataset.labelLess
          : toggle.dataset.labelMore;
        if (label) toggle.textContent = label;
      });
    });
  };

  const initSection = (section) => {
    initAnimation(section);
    initReadMore(section);
  };

  document.querySelectorAll("[data-dietitian-opinion]").forEach(initSection);

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector("[data-dietitian-opinion]");
    if (section) initSection(section);
  });
})();
